import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ReportFiltersMobilePageRoutingModule } from './report-filters-mobile-routing.module';
import { ReportFiltersMobilePage } from './report-filters-mobile.page';
import { TranslateModule } from '@ngx-translate/core';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    IonicModule,
    IonicSelectableModule,
    ReportFiltersMobilePageRoutingModule
  ],
  declarations: [ReportFiltersMobilePage]
})
export class ReportFiltersMobilePageModule {}
